import { Component, Input } from '@angular/core';

@Component({
    selector: 'pagination-summary',
    templateUrl: './pagination-summary.component.html',
    styleUrls: ['./pagination-summary.component.scss'],
    standalone: false
})
export class PaginationSummaryComponent {
  @Input() currentPage: number = 1;
  @Input() itemsPerPage: number = 10;
  @Input() totalItems: number = 0;

  startRange(): number {
    return ((this.currentPage > 1 ? this.currentPage : 1) - 1) * this.itemsPerPage + 1;
  }

  endRange(): number {
    const end =
      ((this.currentPage > 1 ? this.currentPage : 1) - 1) * this.itemsPerPage + this.itemsPerPage;
    return Math.min(end, this.totalItems);
  }
}
